import { Translator } from './translator';
const translator = new Translator();
export default translator;
